var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["readFileSync"]: () => __WEBPACK_EXTERNAL_MODULE_fs__.readFileSync });